import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateVacancyState } from "./types";
import { IJobOpening } from "@/shared/api/employment";
import { fetchCurrentVacancy } from "./update-vacancy-thunk";

const initialState: UpdateVacancyState = {
    isCreateVacancyModalOpen: false,
    isUpdateVacancyModalOpen: false,
    isDeleteVacancyModalOpen: false,
    isEditVacancyFormModalOpen: false,
    currentVacancy: {
        id: "",
        name: "",
        created_at: "",
        salary: "",
        preview: "",
        description: "",
        form: {
            id: "",
            template: []
        }
    },
    onFormEdit: null,
    onCreate: null,
    onDelete: null,
    onUpdate: null
}

interface OpenCreateVacancyModal {
    onSuccess?: () => void
}

interface OpenUpdateVacancyModal {
    data: IJobOpening
    onSuccess?: () => void
}

interface OpenEditVacancyFormModal {
    data: IJobOpening
    onSuccess?: () => void
}

interface OpenDeleteVacancyModal {
    data: IJobOpening
    onSuccess?: () => void
}

const updateVacancySlice = createSlice({
    name: 'updateVacancy',
    initialState,
    reducers: {
        openEditVacancyFormModal: (state, action: PayloadAction<OpenEditVacancyFormModal>) => {
            state.isEditVacancyFormModalOpen = true
            state.currentVacancy = action.payload.data
            state.onFormEdit = action.payload.onSuccess
        },
        openCreateVacancyModal: (state, action: PayloadAction<OpenCreateVacancyModal>) => {
            state.isCreateVacancyModalOpen = true
            state.onCreate = action.payload.onSuccess
        },
        closeCreateVacancyModal: (state) => {
            state.isCreateVacancyModalOpen = false
        },
        openUpdateVacancyModal: (state, action: PayloadAction<OpenUpdateVacancyModal>) => {
            state.isUpdateVacancyModalOpen = true
            state.currentVacancy = action.payload.data
            state.onUpdate = action.payload.onSuccess
        },
        closeUpdateVacancyModal: (state) => {
            state.isUpdateVacancyModalOpen = false
        },
        openDeleteVacancyModal: (state, action: PayloadAction<OpenDeleteVacancyModal>) => {
            state.isDeleteVacancyModalOpen = true
            state.currentVacancy = action.payload.data
            state.onDelete = action.payload.onSuccess
        },
        closeDeleteVacancyModal: (state) => {
            state.isDeleteVacancyModalOpen = false
        },
        closeEditVacancyFormModal: (state) => {
            state.isEditVacancyFormModalOpen = false
        },
    },
    extraReducers(builder) {
        builder.addCase(fetchCurrentVacancy.fulfilled, (state, action) => {
            state.currentVacancy = action.payload
        })
    },
})

export default updateVacancySlice.reducer
export const { 
    closeCreateVacancyModal,
    closeDeleteVacancyModal,
    closeUpdateVacancyModal,
    openCreateVacancyModal,
    openDeleteVacancyModal,
    openUpdateVacancyModal,
    openEditVacancyFormModal,
    closeEditVacancyFormModal
} = updateVacancySlice.actions